export default "__VITE_ASSET__97ed72df__"